import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <Seo
        title="页面未找到 - 吹雪漫画网"
        description="抱歉，你访问的页面不存在或已被移除。返回吹雪漫画网首页，继续发现雪景、冬日、雪国等题材漫画。"
        keywords="吹雪漫画网,404,雪景漫画,冬日漫画"
      />
      <div className="flex min-h-screen flex-col items-center justify-center px-4 pt-24 pb-16 text-center">
        <p className="font-heading text-[8rem] font-black leading-none text-primary-500/20 select-none md:text-[11rem]">404</p>
        <div className="mt-6 max-w-md">
          <h1 className="font-heading text-2xl font-bold text-foreground-950">这一页，被大雪覆盖了</h1>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            你访问的地址 <span className="font-mono text-foreground-500">{location.pathname}</span> 不存在或已被移除。
            不妨回到首页，继续寻找心仪的雪景与冬物语。
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600">
              <i className="ri-home-4-line"></i> 返回首页
            </Link>
            <Link to="/category/xuejing" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700 transition-colors hover:text-foreground-950">
              <i className="ri-book-open-line"></i> 浏览雪景漫画
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}